import { legacyTheme, styled } from '@prose-ui/legacy';

import { Image } from 'Components/Image';

import checkIcon from 'assets/images/check.svg';

import { Typography } from './Typography';

const CheckListWrapper = styled.div`
  margin-top: ${legacyTheme.spacing.s16};
`;

const IngredientWrapper = styled.div`
  margin-bottom: ${legacyTheme.spacing.s8};
`;

const CheckIconWrapper = styled.div`
  position: relative;
  top: -2px;

  float: left;

  width: 12px;
  height: 12px;
  margin-right: ${legacyTheme.spacing.s16};
`;

const IngredientName = styled(Typography)`
  white-space: nowrap;
`;

type NoListCheckedProps = {
  list: string[];
};

export const NoListChecked = ({ list }: NoListCheckedProps) => (
  <CheckListWrapper>
    {list.map((element) => (
      <IngredientWrapper key={element}>
        <CheckIconWrapper>
          <Image alt="✓" height="9" src={checkIcon} width="16" />
        </CheckIconWrapper>

        <IngredientName color="vert" variant="p1">
          {element}
        </IngredientName>
      </IngredientWrapper>
    ))}
  </CheckListWrapper>
);
